import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MailOutlined } from "@ant-design/icons";
import { Space, theme } from "antd";
import { observer } from "mobx-react";
import { BillingAddressInfoCard } from "./billingAddressInfoCard.js";
import { DetailsSkeleton } from "./detailsSkeleton.js";
import { PersonalDataFormCard } from "./personalDataFormCard.js";
import { useStores } from "../../../../../store/stores.js";
import { __, _i } from "../../../../../utils/i18n.js";
import { MATOMO_MASK } from "../../../../../utils/matomoMask.js";
import { InfoCard } from "../../infoCard.js";
const DetailsTab = observer(()=>{
    const { token } = theme.useToken();
    const { accountV2Store } = useStores();
    const { session } = accountV2Store;
    if (!session?.user) {
        return /*#__PURE__*/ _jsx(DetailsSkeleton, {});
    }
    const { email, unconfirmedEmail } = session.user;
    return /*#__PURE__*/ _jsxs(Space, {
        direction: "vertical",
        size: 16,
        style: {
            width: "100%"
        },
        children: [
            unconfirmedEmail && /*#__PURE__*/ _jsx(InfoCard, {
                variant: "primary-soft",
                icon: /*#__PURE__*/ _jsx(MailOutlined, {
                    style: {
                        color: token.colorPrimary
                    }
                }),
                heading: __("Confirm your new email address."),
                leftBorderColor: token.colorPrimary,
                children: _i(__("We've sent a confirmation link to {{unconfirmedEmail}}%s{{/unconfirmedEmail}}. Open it to complete the change. Until then, sign in with {{currentEmail}}%s{{/currentEmail}}.", unconfirmedEmail, email), {
                    unconfirmedEmail: /*#__PURE__*/ _jsx("strong", {
                        ...MATOMO_MASK
                    }),
                    currentEmail: /*#__PURE__*/ _jsx("strong", {
                        ...MATOMO_MASK
                    })
                })
            }),
            /*#__PURE__*/ _jsx(PersonalDataFormCard, {}),
            /*#__PURE__*/ _jsx(BillingAddressInfoCard, {})
        ]
    });
});
export { DetailsTab };
